<div class="formContainer">
  <ng-container *ngIf="!account">
    <div class="login">
      <div>Please login to complete your registration:</div>
      <ng-container>
       <kion-button title="Register" (clicked)="signIn()"></kion-button>
      </ng-container>
    </div>
    <div class="info">
      <div class="infoheading">Please note:</div>
      <ul>
        <li>Please log in to complete your registration</li>
        <li>Don't share this link with anyone else!</li>
        <li>If you need the invitation on another address than the one that you received your invitation at, please ask for another invitation with the correct email address.</li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="account && isCorrectValidationToken">
    <div [formGroup]="form" class="form">
      <label>
        <input type="email" formControlName="email" placeholder="email" disabled />
      </label>
      <label>
        <input type="text" formControlName="firstName" placeholder="first name" />
      </label>
      <label>
        <input type="text" formControlName="lastName" placeholder="last name" />
      </label>
      <button (click)="performRegistration()"> Registrierung abschließen </button>
    </div>
    <div class="info">
      <div class="infoheading">How this works</div>
      <ol>
        <li>Enter your correct name und surname. You cannot change the email since this is bound to a specific invitation.</li>
        <li>Hit the registration button!</li>
        <li>You should now be able to manage properties according to his or her assigned scope.</li>
      </ol>
    </div>
  </ng-container>
</div>
